import React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../../../../Button';
import { MOZZAZ_REDIRECT_URL } from '../../../../../constants/env';

const RedirectToMozzazButton = ({ btnTitle }) => {
  const onGoToMozzaz = () => {
    if (MOZZAZ_REDIRECT_URL) {
      window.open(MOZZAZ_REDIRECT_URL, '_blank', 'noopener', 'noreferrer');
    }
  };

  if (!MOZZAZ_REDIRECT_URL) {
    return null;
  }

  return (
    <Button raised color="primary" onClick={onGoToMozzaz}>
      {btnTitle}
    </Button>
  );
};

RedirectToMozzazButton.propTypes = {
  btnTitle: PropTypes.string,
};

export default RedirectToMozzazButton;



// WEBPACK FOOTER //
// ./src/components/Healthboard/HealthboardHome/components/RedirectToMozzazButton/index.jsx